import type { CameraRoute } from '@datum-sdk/scene-format';

/**
 * The inside-the-Kaaba preloader flights, as SDK scene data — a tour with no
 * flyover: it turns round the preview cloud's own centre, mid-room, and the
 * exit parks on `previewTourEnd` aiming at the room's — the rest pose.
 *
 * Converted once from the legacy `kaabaInsideSceneConfig.camera` by
 * `convertLegacyPreloader.ts` (which says what in here is load-bearing); the
 * routes are the source since. Tune them in the SDK editor (`?flight` → Routes →
 * Copy Routes) — the same workflow as `kaabaRoutes.ts` — and
 * `sceneRoutes.test.ts` holds them to what the preloader and the scene need.
 *
 * The ring runs outside the room's containment box, so the preloader lifts
 * collisions for its routes (`createSdkScene.ts`). The scene is first-person:
 * each route hands the camera back to FPS when it lands.
 */
export const KAABA_INSIDE_CAMERA_ROUTES: CameraRoute[] = [
  {
    id: 'preview-enter',
    waypoints: [
      {
        target: [-6.05, 2.42, -0.08],
        lookAt: [-0.03, 1.85, -0.04],
        duration: 1500,
        easing: [0.65, 0, 0.35, 1],
      },
      {
        orbit: {
          radius: 6.047057135,
          azimuth: -2.951688662,
          polar: 1.476395453,
        },
        target: [-0.03, 1.85, -0.04],
        lookAt: 'target',
        duration: 500,
        easing: [0.333333333, 0, 0.666666667, 0.333333333],
      },
    ],
  },
  {
    id: 'preview-turntable',
    loop: true,
    waypoints: [
      {
        orbit: {
          radius: 6.047057135,
          azimuth: -1.380892335,
          polar: 1.476395453,
        },
        target: [-0.03, 1.85, -0.04],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
      {
        orbit: {
          radius: 6.047057135,
          azimuth: 0.189903992,
          polar: 1.476395453,
        },
        target: [-0.03, 1.85, -0.04],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
      {
        orbit: {
          radius: 6.047057135,
          azimuth: 1.760700319,
          polar: 1.476395453,
        },
        target: [-0.03, 1.85, -0.04],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
      {
        orbit: {
          radius: 6.047057135,
          azimuth: 3.331496646,
          polar: 1.476395453,
        },
        target: [-0.03, 1.85, -0.04],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
    ],
  },
  {
    id: 'preview-exit',
    waypoints: [
      {
        target: [-1.86, 0.25, -3.99],
        lookAt: [0.14, 0.88, -1.45],
        duration: 1000,
        easing: [0.65, 0, 0.35, 1],
      },
    ],
  },
];
